import { render, staticRenderFns } from "./FiltersWrapper.vue?vue&type=template&id=393802b0&scoped=true"
import script from "./FiltersWrapper.vue?vue&type=script&lang=js"
export * from "./FiltersWrapper.vue?vue&type=script&lang=js"
import style0 from "./FiltersWrapper.vue?vue&type=style&index=0&id=393802b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393802b0",
  null
  
)

export default component.exports